import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MultimediaManagerComponent } from './multimedia-manager/multimedia-manager.component';
import { MultimediaManagerDialogComponent } from './multimedia-manager-dialog/multimedia-manager-dialog.component';
import { MultimediaManagerDialogSidenavComponent } from './multimedia-manager-dialog-sidenav/multimedia-manager-dialog-sidenav.component';
import { MultimediaManagerDialogLayoutComponent } from './multimedia-manager-dialog-layout/multimedia-manager-dialog-layout.component';
import { MultimediaManagerDialogItemComponent } from './multimedia-manager-dialog-item/multimedia-manager-dialog-item.component';
import { BrowserModule } from '@angular/platform-browser';
import { MbComponentsModule } from '../mb-components/mb-components.module';
import { MultimediaManagerDialogItemDetailsComponent } from './multimedia-manager-dialog-item-details/multimedia-manager-dialog-item-details.component';
import { HttpClientModule } from '@angular/common/http';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { MultimediaManagerDialogItemFolderComponent } from './multimedia-manager-dialog-item-folder/multimedia-manager-dialog-item-folder.component';
import { MultimediaManagerDialogItemMultimediaComponent } from './multimedia-manager-dialog-item-multimedia/multimedia-manager-dialog-item-multimedia.component';
import { MultimediaManagerDialogUploaderComponent } from './multimedia-manager-dialog-uploader/multimedia-manager-dialog-uploader.component';
import { FromBytesPipe } from './pipes/from-bytes.pipe';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MultimediaManagerDialogUrlComponent } from './multimedia-manager-dialog-uploader/multimedia-manager-dialog-url/multimedia-manager-dialog-url.component';
import { MatRadioModule } from '@angular/material/radio';
import { MultimediaManagerDialogWebscriptComponent } from './multimedia-manager-dialog-uploader/multimedia-manager-dialog-webscript/multimedia-manager-dialog-webscript.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { SpinnerModule } from 'src/app/modules/spinner/spinner.module';
import { SpinnerService } from 'src/app/modules/spinner/spinner.service';
import { YoutubeEmbedSafeUrlPipe } from './pipes/youtube-embed-safe-url-pipe/youtube-embed-safe-url.pipe';
import { SafeImagePipe } from './pipes/safe-image-pipe/safe-image.pipe';
import { LottieAnimationViewModule } from 'ng-lottie';
import { MultimediaManagerDownloadsComponent } from './multimedia-manager-downloads/multimedia-manager-downloads.component';
import { MultimediaManagerDialogEditorComponent } from './multimedia-manager-dialog-editor/multimedia-manager-dialog-editor.component';
import { MultimediaManagerCropperComponent } from './multimedia-manager-cropper/multimedia-manager-cropper.component';
import { MatSlider, MatSliderModule } from '@angular/material';
import { PhotoEditorModule } from '../photo-editor/photo-editor.module';
import {MatOptionModule} from "@angular/material/core";
import {MatSelectModule} from "@angular/material/select";

@NgModule({
  declarations: [
    MultimediaManagerComponent,
    MultimediaManagerDialogComponent,
    MultimediaManagerDialogSidenavComponent,
    MultimediaManagerDialogLayoutComponent,
    MultimediaManagerDialogItemComponent,
    MultimediaManagerDialogItemDetailsComponent,
    MultimediaManagerDialogItemFolderComponent,
    MultimediaManagerDialogItemMultimediaComponent,
    MultimediaManagerDialogUploaderComponent,
    FromBytesPipe,
    MultimediaManagerDialogUrlComponent,
    MultimediaManagerDialogWebscriptComponent,
    YoutubeEmbedSafeUrlPipe,
    SafeImagePipe,
    MultimediaManagerDownloadsComponent,
    MultimediaManagerDialogEditorComponent,
    MultimediaManagerCropperComponent
  ],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    HttpClientModule,
    MbComponentsModule,
    DragDropModule,
    MatButtonModule,
    MatMenuModule,
    MatButtonToggleModule,
    MatRadioModule,
    MatSliderModule,
    TranslateModule,
    SpinnerModule,
    PhotoEditorModule,
    LottieAnimationViewModule.forRoot(),
    ReactiveFormsModule,
    MatOptionModule,
    MatSelectModule
  ],
  providers: [
    SpinnerService
  ],
  exports: [
    MultimediaManagerComponent
  ],
  entryComponents: [
    MultimediaManagerDialogUrlComponent,
    MultimediaManagerDialogWebscriptComponent
  ]
})
export class MultimediaManagerModule { }
